<template>
  <div>
    <div class="message" v-if="tableData.length>0">
      <i class="el-icon-info"></i>
      <p v-if="proStatus">当前展示的是已发布到线上的功能定义,如需编辑,请先撤销发布</p>
      <p v-else>当前展示的是已发布到线上的功能定义,如需修改,请点击<span @click="toEdit"> 编辑草稿</span></p>
    </div>
    <div class="function-definition">
      <div class="btn-group">
          <!-- <el-button type="primary" @click="handlerClick('addBasic')">添加标准功能</el-button>
          <el-button  @click="handlerClick('addCustom')">添加自定义功能</el-button>
          <el-button  @click="handlerClick('into')">快速导入</el-button> -->
          <el-button type="primary" @click="handlerClick('add')" v-if="tableData.length<1">编辑草稿</el-button>
          <el-button  @click="handlerClick('PhysicalModel')">物模型TSL</el-button>
          <!-- <el-button  @click="handlerClick('look')">生成设备端代码</el-button> -->
      </div>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        style="width: 100%">
        <template slot="empty">
          <emptyView style="margin:10px" :funDefinitionFlag="funDefinitionFlag" @emitToEdit="toEdit">
          </emptyView>
        </template>
        <el-table-column
          prop="parentId"
          label="功能类型"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="name"
          label="功能名称"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="identifier"
          label="标识符"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="types"
          label="数据类型/调用方式/事件类型"
          align="center"
          >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          >
           <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handlerView(scope.$index, scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
     <!-- 快速导入dialog -->
    <!-- <modelDialog @close-view="showImportModel.show = false" @getImportPhyData="getImportPhyData" :showImportModel="showImportModel" :importPhydata="importPhydata"/> -->
      <!-- 物模型数据展示dialog -->
    <physicalModelDailog  @open="openPhyDailog" :resData="resData" :dialogVisible="dialogVisible"/>
       <!-- 编辑或查看dialog -->
    <viewMoreDailog  :date="importPhydata.date" @open-view-dialog="openViewDailog" :rowsdata="rowsData" :infosDialogVisible="infosDialogVisible"/>
    <!-- 添加自定义dialog -->
    <!-- <addCustomDailog v-if="addCustomDialogVisible" @open-addcustom-dialog="addCustomDialogVisible=false" :addCustomDialogVisible="addCustomDialogVisible"/> -->

  </div>
</template>

<script>
import emptyView from '@/components/empty_view/empty'
import { getThingModel, unitsName } from '@/api/productRegistration'
import physicalModelDailog from '@/components/functionDefinitionDailogs/PhysicalModelDailog'
import viewMoreDailog from '@/components/functionDefinitionDailogs/viewMoreDailog'
import { mapGetters } from 'vuex'
// import addCustomDailog from '@/components/functionDefinitionDailogs/addCustomDailog'
// import modelDialog from '@/components/functionDefinitionDailogs/importModelDialog'
export default {
  data () {
    return {
      tableData: [],
      sRow: null,
      dialogVisible: false,
      infosDialogVisible: false,
      resData: [],
      rowsData: {},
      /* showImportModel: { // modelDialog开关
        show: false
      }, */
      importPhydata: {
        beforeKey: '',
        date: Date.parse(new Date())
      },
      addCustomDialogVisible: false, // addcustomdialog开关
      uName: ''
    }
  },
  components: {
    emptyView,
    physicalModelDailog,
    viewMoreDailog
    // addCustomDailog,
    // modelDialog
  },
  computed: {
    ...mapGetters(['proStatus']),
    funDefinitionFlag () {
      if (this.tableData.length === 0) {
        return true
      } else {
        return false
      }
    }

  },
  async created () {
    if (localStorage.getItem('infos')) {
      this.sRow = JSON.parse(localStorage.getItem('infos'))
    } else {
      this.sRow = JSON.parse(this.$route.query.sRow)
    }
    this.getThingModelData()
  },
  methods: {
    getImportPhyData (val) {
      this.getThingModelData(val)
    },
    getThingModelData (val) {
      this.tableData = []
      const params = {
        params: {
          productKey: val || this.sRow.productKey
        }
      }
      getThingModel(params).then(res => {
        this.resData = res.data.data.thingModel // 模型数据展示时需要profile'
        const physicalModelData = Object.assign({}, res.data.data.thingModel)
        delete physicalModelData.profile
        // console.log(Object.values(physicalModelData).reverse())
        for (let index = 0; index < Object.values(physicalModelData).length; index++) {
          Object.values(physicalModelData)[index].forEach((item) => {
            if (index === 0) {
              item.parentId = '服务'
            } else if (index === 1) {
              item.parentId = '属性'
            } else {
              item.parentId = '事件'
            }
          })
        }
        Object.values(physicalModelData).forEach((item) => {
          item.forEach((ele) => {
            if (ele.callType) ele.types = ele.callType
            if (ele.dataType) ele.types = ele.dataType.type
            if (ele.type) ele.types = ele.type
            // if (ele.accessMode) ele.accessMode = ele.accessMode === 'r' ? '只读' : '读写'
            this.tableData.push(ele)
          })
        })
        console.log(this.tableData)
      }).then(() => {
        this.getUnitsName()
      })
    },
    getUnitsName () {
      const params = {
        params: {}
      }
      unitsName(params).then((res) => {
        res.data.data.forEach((item) => {
          this.uName = item.unitName + '/' + item.unit
          item.uName = this.uName
        })
        console.log(res.data.data)
        sessionStorage.setItem('selList', JSON.stringify(res.data.data))
      })
    },
    openPhyDailog (val) {
      this.dialogVisible = val
    },
    // 打开查看Dialog
    openViewDailog (val) {
      this.infosDialogVisible = val
    },
    handlerClick (val) {
      switch (val) {
        case 'addBasic':
          console.log('addBasic')
          break
        case 'addCustom':
          this.addCustomDialogVisible = true
          console.log('addCustom')
          break
        case 'into':
          this.importPhydata.date = Date.parse(new Date())
          this.importPhydata.beforeKey = this.sRow.productKey
          // this.showImportModel.show = true
          break
        case 'PhysicalModel':
          this.dialogVisible = true
          break
        case 'look':
          console.log('look')
          break
        case 'add':
          this.toEdit()
          break
      }
    },
    // 查看详情按钮
    handlerView (sIndex, sRow) {
      console.log(sIndex, sRow)
      this.infosDialogVisible = true
      this.importPhydata.date = Date.parse(new Date())
      sRow.status = 'view'
      sRow.index = sIndex
      this.rowsData = sRow
    },
    // 编辑功能
    /* handlerEdit (index, row) {
      this.importPhydata.date = Date.parse(new Date())
      this.infosDialogVisible = true
      row.status = 'edit'
      row.index = index
      this.rowsData = row
      console.log(index, row)
    }, */
    toEdit () {
      this.sRow = JSON.stringify(this.sRow)
      this.$router.push({
        path: '/productControl/functionDefinitionEdit',
        query: {
          sRow: this.sRow
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .message{
    margin-bottom: 12px;
    padding: 12px 12px 12px 16px;
    display: flex;
    background-color: #e5f3ff;
    align-items: center;
    letter-spacing: 1px;
    i{
      color: skyblue;
    }
    p{
      font-size: 12px;
      span{
        color: #0070cc;
        cursor: pointer;
      }
    }
  }
  .function-definition{
    margin-bottom: 20px;
    .btn-group{
      display: flex;
      .left{
        margin-right: 10px;
      }

    }
    .el-button--default{
      background-color: #fafafa;
    }
    .el-button--default, .el-button--primary{
      border-radius: 0;
      padding: 0 16px;
      line-height: 30px;
      font-size: 12px;
      border-width: 1px;
    }
  }
</style>
